import { MessageFile } from "./MessageFile";
import { getFileNameFromUrl } from "./utils";
import type { Message } from "@interfaces/chat.interface";

interface MessageFileContentProps {
  message: Message;
  onDownload?: (url: string) => void;
  pageId?: string | null;
}

export const MessageFileContent = ({
  message,
  onDownload,
  pageId,
}: MessageFileContentProps) => {
  if (
    message.attachments &&
    Array.isArray(message.attachments) &&
    message.attachments.length > 0
  ) {
    const fileAttachments = message.attachments.filter(
      (att) => att.type === "file"
    );

    if (fileAttachments.length > 0) {
      const fileAttachment = fileAttachments[0];
      const fileUrl = fileAttachment.url || "";
      const fileName = fileAttachment.name || getFileNameFromUrl(fileUrl) || "Tệp đính kèm";

      return (
        <MessageFile
          fileUrl={fileUrl}
          fileName={fileName}
          onDownload={onDownload}
          messageId={message.id}
          conversationId={message.conversationId}
          pageId={pageId}
        />
      );
    }
  }

  const attachments = message.meta?.attachments as
    | Array<{
        type: string;
        payload?: { url?: string };
        url?: string;
        name?: string;
      }>
    | undefined;

  if (attachments && Array.isArray(attachments) && attachments.length > 0) {
    const fileAttachments = attachments.filter((att) => att.type === "file");

    if (fileAttachments.length > 0) {
      const fileAttachment = fileAttachments[0];
      const fileUrl = fileAttachment.payload?.url || fileAttachment.url || "";
      const fileName =
        fileAttachment.name || getFileNameFromUrl(fileUrl) || "Tệp đính kèm";

      return (
        <MessageFile
          fileUrl={fileUrl}
          fileName={fileName}
          onDownload={onDownload}
          messageId={message.id}
          conversationId={message.conversationId}
          pageId={pageId}
        />
      );
    }
  }

  const fileUrl: string | undefined =
    (message.meta?.fileUrl as string | undefined) ||
    (message.meta?.attachmentId as string | undefined) ||
    (message.body as string | undefined);

  const fileName: string =
    (message.meta?.fileName as string | undefined) ||
    (fileUrl ? getFileNameFromUrl(fileUrl) : undefined) ||
    (message.body as string | undefined) ||
    "Tệp đính kèm";

  return (
    <MessageFile
      fileUrl={fileUrl}
      fileName={fileName}
      onDownload={onDownload}
      messageId={message.id}
      conversationId={message.conversationId}
      pageId={pageId}
    />
  );
};
